import { Forms, Modal, SaveButton, SystemText } from 'e4shared';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import config from 'config';
import { addImage, clearImage, setShowSuccess, toggleFormHelp } from 'actions/ui';
import { filePromises } from 'actions/admin';
import axios from 'axios';
import { apiCode, apiConfig } from 'services';
import { setUserAvatar } from 'actions/user';

export const EditImage = ({ show, onClose }) => {
    const dispatch = useDispatch();

    const [saving, setSaving] = React.useState(false);
    const [avatar, setAvatar] = React.useState('');
    const [meta, setMeta] = React.useState('');

    const user = useSelector(state => state.user.user);
    const { images } = useSelector(state => state.ui);

    React.useEffect(() => {
        if (show) {
            setAvatar(user?.avatar);
        }
    }, [show]);

    const st = (path, ...rest) => SystemText(`Header/ImageEdit/${path}`, ...rest);

    const save = () => {
        const profile = { ...user };
        profile.avatar = typeof avatar === 'object' ? avatar : avatar.split('?')[0];

        profile.avatarMeta = meta;

        return Promise.all(filePromises(profile, ['avatar'], user.guid, config)).then(() =>
            axios
                .patch(`${config.apiGateway.URL}profile-image${apiCode()}`, profile, apiConfig(user.guid))
                .then(() => {
                    dispatch(setShowSuccess(st('Success')));
                    dispatch(clearImage('avatar', profile.avatar));
                })
                .then(() => {
                    dispatch(setUserAvatar(profile.avatar));
                    onClose();
                })
                .finally(() => setSaving(false))
        );
    };

    const footer = (
        <div>
            <SaveButton
                id="image-save-button"
                saving={saving}
                setSaving={setSaving}
                className="btn btn-success"
                onClick={save}
            >
                {st('Buttons/Save')}
            </SaveButton>
            <button data-testid="image-cancel-button" className="btn" onClick={onClose}>
                {st('Buttons/Cancel')}
            </button>
        </div>
    );

    return (
        <Modal
            show={show}
            title={st('Title')}
            close={onClose}
            footer={footer}
            toggleFormHelp={() => dispatch(toggleFormHelp())}
        >
            <Forms.Image
                help={st('Help')}
                value={avatar}
                onChange={setAvatar}
                onMetaChange={setMeta}
                label={st('Label')}
                folder="avatar"
                ratio={1}
                config={config}
                data-testid="image-avatar"
                addImage={(folder, src) => dispatch(addImage(folder, src))}
                images={images}
            />
        </Modal>
    );
};

export default EditImage;
